import React, { createContext, ReactNode, useMemo } from 'react'

import { TopDestinationsType } from 'src/types/topDestinations'

const TopDestinationsContext = createContext<TopDestinationsType | null>(null)

interface ITopDestinationsProviderProps {
  children: ReactNode
  value: TopDestinationsType | null
}

const TopDestinationsProvider = ({ children, value }: ITopDestinationsProviderProps) => {
  if (value === null) {
    throw new Error('TopDestinationsContext provider can not have a null value')
  }

  const { destinations } = value

  const topDestinationsValue = useMemo(
    () => ({
      destinations,
    }),
    [destinations]
  )

  return (
    <TopDestinationsContext.Provider value={topDestinationsValue}>
      {children}
    </TopDestinationsContext.Provider>
  )
}

export { TopDestinationsContext, TopDestinationsProvider }
